import React from 'react';
import { useTranslation } from 'react-i18next';

import classes from './TripStatus.module.scss';

interface Props {
	status: string;
}

const TripStatus: React.FC<Props> = ({ status }: React.PropsWithChildren<Props>) => {
	const { t } = useTranslation();

	return (
		<div className={classes['container']}>
			<p className={classes['text']}>{t(`tripStatus.${status}`)}</p>
		</div>
	);
};

export default TripStatus;
